<template>
<!--##############################################################################################
#####   For use this component he need one props named "options" made up of :
#####      * One "title"
#####     * Into options one array named "items" made up of :
#####         * One key "titleRadio" for title and "label" for the label for the radio 
#####        * One key "selectData" for the data into the select (into this array, place one key "data" for so that the display be unique )
##### The props radio is optional for set or not the radio
#####
##### The return is "row" for the value of the select and "radio" for the value of radio 
###################################################################################################-->

    <!-- TITLE OF THE BLOCK -->
    <el-form-item :label="options.title" class="">
            {{ options.items.length}}
        <div class="well flex-level " :class="containerClass(index)" v-for="(item, index ) in options.items" :key="item.label">
            <!-- RADIO CHOICE -->
            <el-radio
                v-model="radio"
                :label="item.label"
                @change="updateRadio"
                >
                {{ item.titleRadio }}
                
            </el-radio>
            <!-- SELECT -->
            <el-form-item prop="select" class="flex-right">
                <el-select
                    v-model="item.data"
                    :disabled="radio !== item.label"
                    @change="updateSelect"
                    >
                    <el-option 
                        v-for="row in item.selectData"
                        :key="row.value"
                        :label="row.label"
                        :value="row.value"
                        >
                    </el-option>
                </el-select>
            </el-form-item>
        </div>
    </el-form-item>
</template>

<script>
export default {
    props: {
        options : {
            type : Object,
            required : true,
        },
        radioSelected : {
            type : String,
            required : false ,
            default : "",      
        }
    },
    data() {
        return {
            radio   : this.radioSelected !== '' ? this.radioSelected : '',
        }
    },
    methods : {
        updateSelect(row) {
            this.$emit('updateSelect', { select: row});
        },
        updateRadio(row) {
            this.$emit('updateRadio', { radio: row});
        },
        containerClass(index) {
            return {
                'bb-0 br-bottom-0': index == 0, 
                'br-top-0': index == Object.keys(this.options.items).length - 1
            };
        }
    }
}
</script>